import axios from 'axios'

export default ($http) => ({
  fetchForCurriculumMap(id, yearId) {
    return $http.get(`units/curriculum-map/${id}${yearId ? `?yearId=${yearId}` : ''}`)
  },
  addNewUnit(payload) {
    return $http.post('units', { body: payload })
  },
  updateUnit(id, payload) {
    return $http.put(`units/${id}`, { body: payload })
  },
  getUnitWithLessons(query) {
    if (!query.yearId) delete query.yearId
    return $http.get(`unit-with-lessons/${query.id}`, { query: { ...query } })
  },
  fetchUnit(id) {
    return $http.get(`units/${id}`)
  },
  fetchUnitWithCurriculum(id, yearId, hasDefaultRedirect) {
    if (yearId) return $http.get(`unit/${id}/with-curriculum`, { query: { yearId }, hasDefaultRedirect })
    return $http.get(`unit/${id}/with-curriculum`, { hasDefaultRedirect })
  },
  fetchUnitComplexChecklistData(unitId) {
    return $http.get(`unit/${unitId}/complex-checklist`)
  },
  createUnitComplexChecklistData(unitId, payload) {
    return $http.post(`unit/${unitId}/complex-checklist`, { body: payload })
  },
  updateUnitComplexChecklistData(unitId, entityId, payload) {
    return $http.put(`unit/${unitId}/complex-checklist/${entityId}`, { body: payload })
  },
  updateLessonsOrder(id, payload) {
    return $http.put(`units/${id}/sort-lessons`, { body: payload })
  },
  getUnitBreadcrumbData(unitId, yearId) {
    if (yearId) return $http.get(`units/breadcrumb/${unitId}`, { query: { yearId }, hasNotification: false })
    return $http.get(`units/breadcrumb/${unitId}`, { hasNotification: false })
  },
  addToFavorites(unitId) {
    return $http.post(`units/add-to-favorites/${unitId}`)
  },
  removeFromFavorites(unitId) {
    return $http.delete(`units/remove-from-favorites/${unitId}`)
  },
  fetchTeachersForSharingUnit(payload) {
    return $http.post('email-recipients/search', { body: payload })
  },
  shareUnit(unitId, payload) {
    return $http.post(`share/unit/${unitId}`, { body: payload })
  },
  fetchUnitActivity(unitId, params) {
    return $http.get(`unit/${unitId}/activity`, { query: params })
  },
  fetchUnitStandardsForCategory(unitId, categoryId) {
    return $http.get(`unit/${unitId}/category/${categoryId}/selected-standards`)
  },
  saveUnitStandardsForCategory(unitId, categoryId, selectedStandards) {
    return $http.put(`unit/${unitId}/category/${categoryId}/selected-standards`, { body: { selectedStandards } })
  },
  refrontloadCategory(unitId, categoryId = null) {
    return axios.get('/Atlas/Controller?Actions=' + JSON.stringify({
      saveFrontLoadedCurriculum: {
        Object: {
          Type: 'Unit',
          UnitID: unitId
        },
        Method: 'AsyncSaveFrontLoadedCurriculum',
        Parameters: {
          ...(categoryId ? { MappingCategoryID: categoryId } : { FILTER_STANDARDS_CATEGORIES: 1 }),
          SAVE_OPTION_UPDATE_LAST_UPDATED: true
        }
      }
    }))
  },
  refrontloadUnits(unitIds, categoryId) {
    unitIds.forEach(unitId => {
      this.refrontloadCategory(unitId, categoryId)
    })
  },
  fetchUnitSavedStandardsFiltersForCategory(unitId, categoryId) {
    return $http.get(`unit/${unitId}/category/${categoryId}/saved-standards-filters`)
  },
  saveUnitSavedStandardsFiltersForCategory(unitId, categoryId, payload) {
    return $http.put(`unit/${unitId}/category/${categoryId}/saved-standards-filters`, { body: payload })
  },
  recycleUnit(unitId) {
    return $http.delete(`units/${unitId}`)
  },
  lockUnitCategory(unitId, categoryId) {
    return $http.post(`unit/${unitId}/category/${categoryId}/lock`)
  },
  createAssessmentAndLinkToUnit(unitId, lessonId, payload) {
    return $http.post(`unit/${unitId}/create-assessment-and-link-to-lesson/${lessonId}`, { body: payload })
  },
  lockUnitCategoryUpdate(unitId, categoryId, payload) {
    return $http.put(`unit/${unitId}/category/${categoryId}/lock`, { body: payload })
  },
  unlockUnitCategory(unitId, categoryId) {
    return $http.delete(`unit/${unitId}/category/${categoryId}/lock`)
  },
  checkIfUnitCategoryLocked(unitId, categoryId) {
    return $http.get(`unit/${unitId}/category/${categoryId}/lock`)
  },
  updateUnitCategory(unitId, categoryId, payload) {
    return $http.put(`unit/${unitId}/category/${categoryId}/update`, { body: payload })
  },
  updateAndUnlockUnitCategory(unitId, categoryId, payload) {
    return $http.put(`unit/${unitId}/category/${categoryId}/update-and-unlock`, { body: payload })
  },
  getOpenAiSuggestion(unitId, categoryId, payload) {
    return $http.post(`unit/${unitId}/category/${categoryId}/get-openai-suggestion`, { body: payload, timeout: 120000 })
  },
  getUnitCategoryCurriculum(unitId, categoryId) {
    return $http.get(`unit/${unitId}/category/${categoryId}/curriculum`)
  },
  fetchUnitAssessments(unitId) {
    return $http.get(`unit/${unitId}/assessments`)
  },
  fetchUnitAssessmentById (unitId, assessmentId, config = {}) {
    return $http.get(`/unit/${unitId}/assessments/${assessmentId}`, { ...config })
  }
})
